import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueQrcode from '@chenfengyuan/vue-qrcode';
//import Config from '../lib/configuration';
import { Plugin as VideoPlayerPlugin } from 'vue-responsive-video-background-player'

Vue.config.productionTip = false

Vue.use(require('vue-moment'));
Vue.use(VideoPlayerPlugin);
Vue.component(VueQrcode.name, VueQrcode);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
